import clsx from 'clsx';
import { useEffect } from 'react';
import { X } from 'react-feather';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import { ExpirationPaymentStatus, ExpirationPaymentStatuses } from '../enums/expiration-payment-status';
import { ExpirationPayment } from '../interfaces/expiration-payment';
import { ExpirationPaymentUpdateStatusDto } from '../interfaces/expiration-payment-update-status.dto';
import { api } from '../services/api';
import { expirationPaymentStatusToString } from '../services/helpers';
import myToastr from '../services/toastr';

interface Props {
  closeModal: (result: boolean) => void;
  expirationPayment: ExpirationPayment | null;
  open: boolean;
}

const ExpirationPaymentModal = ({ closeModal, expirationPayment, open }: Props) => {
  const {
    formState: { errors, isDirty },
    handleSubmit,
    register,
    reset,
  } = useForm<ExpirationPaymentUpdateStatusDto>({
    mode: 'onSubmit',
    defaultValues: {
      status: ExpirationPaymentStatus.Pending,
    },
  });

  useEffect(() => {
    if (open && expirationPayment) {
      reset({
        status: expirationPayment.status,
      });
    } else if (!open) {
      reset();
    }
  }, [open, expirationPayment, reset]);

  const close = () => {
    closeModal(false);
  };

  const onSubmit = async (formData: ExpirationPaymentUpdateStatusDto) => {
    if (!isDirty) {
      closeModal(false);
      return;
    }
    try {
      await api.updateExpirationPaymentStatus(expirationPayment!.id, formData);
      closeModal(true);
      myToastr.success('Vencimiento actualizado correctamente');
    } catch (e: any) {
      myToastr.error(e.response.data.message);
    }
  };

  return (
    <Modal className="vercomi-modal my-form brand-modal" isOpen={open} onRequestClose={close} shouldCloseOnOverlayClick={false}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="content">
          <div className="d-flex justify-content-between mb-3">
            <div className="title">Actualizar vencimiento</div>
            <button className="close-button-modal" onClick={close} title="Cerrar" type="button">
              <X size={16} />
            </button>
          </div>
          <div className="row my-3">
            <div className="col">
              <div className={clsx('input-name', { error: errors?.status })}>Estado</div>
              <select {...register('status', { required: 'El estado es obligatorio' })} className={clsx({ error: errors?.status })}>
                {ExpirationPaymentStatuses.map((status) => (
                  <option key={status} value={status}>
                    {expirationPaymentStatusToString(status)}
                  </option>
                ))}
              </select>
              {errors.status && <div className="error-message">{errors.status.message}</div>}
            </div>
          </div>
        </div>
        <button className={`save-button`} type="submit">
          Guardar
        </button>
      </form>
    </Modal>
  );
};

export default ExpirationPaymentModal;
